import React, { useRef } from 'react';

/**
 * Wraps its children in a div that translates slightly toward the pointer,
 * giving CTAs a "magnetic" feel. Ported from Breww landing.
 * Respects prefers-reduced-motion (becomes a plain wrapper).
 */
const MagneticButton = ({ children, strength = 0.35, className = '', style = {} }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const relX = e.clientX - rect.left - rect.width / 2;
    const relY = e.clientY - rect.top - rect.height / 2;
    el.style.transform = `translate(${relX * strength}px, ${relY * strength}px)`;
  };
  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = 'translate(0, 0)';
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`inline-block transition-transform duration-200 ease-out will-change-transform ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default MagneticButton;
